const values = new Map<string, any>();
const _window = window as any;

let storage = {
    setItem(key: string, value: any) {
        values.set(key, value);
    },
    getItem(key: string) {
        return values.get(key);
    },
    removeItem(key: string) {
        values.delete(key);
    },
};

try {
    _window.localStorage.setItem("__test__", "__test__");
    _window.localStorage.getItem("__test__");
    storage = _window.localStorage;
} catch (e) {
    try {
        _window.sessionStorage.setItem("__test__", "__test__");
        _window.sessionStorage.getItem("__test__");
        storage = _window.sessionStorage;
    } catch (e) {}
}

export default storage as {
    getItem(key: string): any;
    setItem(key: string, value: any): void;
    removeItem(key: string): void;
};
